import type { Y } from '@piccolohealth/pbs-common';
import { ChakraV3, Empty } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import React from 'react';
import { MdChecklist } from 'react-icons/md';
import { useScoringChecklist } from '../hooks/useScoringChecklist';
import { TemplateScoringChecklistEditor } from '../scoring/TemplateScoringChecklistEditor';

interface Props {
  yDoc: Y.Doc;
}

export const ParticipantDocumentScoringEditor = (props: Props) => {
  const { yDoc } = props;

  const { checklist, addChecklist, updateChecklist } = useScoringChecklist({ yDoc });

  const content = P.run(() => {
    if (!checklist) {
      return (
        <Empty
          title='No scoring checklist'
          description={`Create a scoring checklist to score participant documents created with this template`}
          extra={
            <ChakraV3.Button colorPalette='brand' size='sm' onClick={addChecklist}>
              Create checklist
            </ChakraV3.Button>
          }
          icon={
            <ChakraV3.Icon boxSize='48px' color='gray.300'>
              <MdChecklist />
            </ChakraV3.Icon>
          }
        />
      );
    }

    return <TemplateScoringChecklistEditor checklist={checklist} onUpdate={updateChecklist} />;
  });

  return (
    <ChakraV3.Stack flex={1} overflowY='auto' px={4} mt={2} mb={4}>
      <ChakraV3.Stack ml='auto' mr='auto' maxW='858px' w='full'>
        {content}
      </ChakraV3.Stack>
    </ChakraV3.Stack>
  );
};
